var map = {
  "./ADMINISTRATIVO.svg": "197879",
  "./ANALISE.svg": "495066",
  "./APAC.svg": "276324",
  "./BUSCA_ATIVA.svg": "314809",
  "./CONECTA.svg": "764708",
  "./CONSOLE.svg": "114950",
  "./CONTRARREFERENCIA.svg": "230610",
  "./DRA.svg": "653394",
  "./EEG.svg": "43304",
  "./ELETROCARDIOGRAFIA.svg": "277164",
  "./ESPIROMETRIA.svg": "980853",
  "./ESTOMATO.svg": "312733",
  "./EXAMES.svg": "265806",
  "./GESTAOPACS.svg": "892597",
  "./HELPDESK.svg": "24321",
  "./MENSAGENS.svg": "296636",
  "./NEXUS.svg": "467736",
  "./OAUTH2.svg": "2414",
  "./OXIGENOTERAPIA.svg": "863910",
  "./PATOLOGIA.svg": "266291",
  "./POLISSONOGRAFIA.svg": "190631",
  "./RETINOGRAFIA.svg": "752496",
  "./RSE.svg": "582639",
  "./TELEATENDIMENTO.svg": "569423",
  "./TELECONSULTORIAS.svg": "447671",
  "./TELEDERMATO.svg": "24845",
  "./TELEEDUCACAO.svg": "264372",
  "./TFD.svg": "98299",
  "./TFDPASSAGENS.svg": "836232"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 577386;
